import { useIntl } from '@/intl'

import { useResults } from '@/scopes/search/search/domain/hooks'

import { mqMax, mqMin, tok } from '@sunwebgroup/ui-components'
import { Skeleton, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

interface ResultsCounterProps {
  isLoading?: boolean
}

const Wrapper = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};
`

const ResultsTextMobile = styled(Typography)`
  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: none;
  }
`
const ResultsTextOtherBreakPoint = styled(Typography)`
  @media ${mqMax('primitives_breakpoint_s_max')} {
    display: none;
  }
`

export function ResultsCounter({ isLoading }: ResultsCounterProps) {
  const intl = useIntl()
  const { totalResults } = useResults()

  if (isLoading) {
    return <Skeleton />
  }

  // TODO duplicated breakpoint for mobile and for the rest of breakpoints due to search_results_sun includes
  // the number in the translation. After being migrated to UDS. The translation should be changed to don't have the number and then
  // always show the number and have another typography where search_results_sun is hide when breakpoint is mobile
  return (
    <Wrapper data-qa="total-results">
      <ResultsTextOtherBreakPoint $variant="body-m-bold-tight">{intl.formatMessage({ id: 'search_results_sun' }, { nrOfResults: totalResults })}</ResultsTextOtherBreakPoint>
      <ResultsTextMobile $variant="body-m-bold-tight">{totalResults}</ResultsTextMobile>
    </Wrapper>
  )
}
